// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-layouts-post-index-tsx": () => import("./../../../src/layouts/Post/index.tsx" /* webpackChunkName: "component---src-layouts-post-index-tsx" */),
  "component---src-layouts-reference-index-tsx": () => import("./../../../src/layouts/Reference/index.tsx" /* webpackChunkName: "component---src-layouts-reference-index-tsx" */),
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */)
}

